import { useFetchData } from "../../../hooks/useFetch";
import { BaseResponse } from "../../../models/response/base-response";
import { ApiConfig, API_SERVICE_TYPE_MAPS_ROUTER } from "../../../services/api-config";

export interface Service {
  id: number;
  name: string;
  image_url?: string;
}

export interface ServiceType {
  id: number;
  name: string;
}

export interface ServiceMap {
  id: number;
  service_type_id: number;
  service_id: number;
  price: number | string;
  service?: Service | null;
  serviceType?: ServiceType | null;
  service_type?: ServiceType | null;
  service_name?: string;
  service_type_name?: string;
  store_name?: string;
  image_url?: string;
}

export interface ServiceMapListFilters {
  status?: number;
  branch_id?: number;
  store_id?: number;
  service_type_id?: number;
  limit?: number;
  page?: number;
}
export interface ServiceMapListFiltersV2 {
  status?: number;
  branch_id?: number;
  store_id?: number;
  limit?: number;
  page?: number;
}

export const ServiceMapService = {
  listByType: () => {
    const { request, baseResponse, loading } =
      useFetchData.Get<ServiceMap[]>({
        projectId: ApiConfig.PROJECT_ID.PRODUCT_SERVICE,
      });

    return {
      fetch: (
        serviceTypeId: number,
        params: ServiceMapListFilters = { status: 1 }
      ): Promise<BaseResponse<ServiceMap[]> | undefined> =>
        request({
          endPoint: API_SERVICE_TYPE_MAPS_ROUTER.API_LIST,
          data: {
            ...params,
            service_type_id: serviceTypeId,
          },
        }),
      response: baseResponse,
      loading,
    };
  },
  listActive: () => {
    const { request, baseResponse, loading } =
      useFetchData.Get<ServiceMap[]>({
        projectId: ApiConfig.PROJECT_ID.PRODUCT_SERVICE,
      });
    return {
      fetch: (params: ServiceMapListFiltersV2 = { status: 1 }): Promise<BaseResponse<ServiceMap[]> | undefined> =>
        request({
          endPoint: API_SERVICE_TYPE_MAPS_ROUTER.API_LIST,
          data: params,
        }),
      response: baseResponse,
      loading: loading,
    };
  },
};

export default ServiceMapService;
